import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
  Box,
  Tab,
  Tabs,
} from "@material-ui/core";
import SimpleDialogDemo from "../../Modals/SimpleDialog";
import { useParams } from "react-router-dom";

import BusinessCreate from "./BusinessCreate";
import BusinessConfiguration from "./BusinessConfiguration";
import OrganizerWebContainer from "../OrganizerWeb/OrganizerWebContainer";
import BusinessWebCreate from "../OrganizerWeb/BusinessWebCreate";
import TournamentsContainer from "../TournamentsConfig/TournamentsContainer";
import AccountData from "../Accounts/AccountData";
import ParticipantsData from "../Participants/ParticipantsData";
import TotalesEventos from "./TotalesEventos";
import GameContainer from "../../TeamSports/GameContainer";
import Cotizacion from "./Cotizacion";
import ListaCotizaciones from "./ListaCotizaciones";
import ExportInscritosByBusiness from "./ExportInscritosByBusiness";
import AddUserMultipleEvents from "./AddUserMultipleEvents";
import DownloadEventsDeposits from "../Accounts/DownloadEventsDeposits";
import Chats from "../../Whatsapp/Chats";

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <div hidden={value !== index} style={{ width: "100%" }}>
      {value === index && (
        <Box pt={3} style={{ width: "100%", overflowX: "auto" }}>
          <div style={{ minWidth: "100%" }}>
            {children}
          </div>
        </Box>
      )}
    </div>
  );
}

export default function BusinessConfigurationContainer(props) {
  const { subEventIndex, subEvent } = props;
  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);
  const events = useSelector((state) => state.events.events);
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const [business, setBusiness] = useState(false);
  const [tabValue, setTabValue] = useState(0);

  const businessGeneralData = useSelector(
    (state) => state.organizer.businessGeneralData
  );

  let { businessId } = useParams();

  useEffect(() => {
    if (atleteAccount && atleteAccount.businessAuth) {
      setBusiness(
        Object.values(atleteAccount.businessAuth).filter(
          (a) => a.profile !== "noauth" && a.businessId === businessId
        )[0]
      );
    }
  }, [atleteAccount, businessId]);

  const showVariosTab = businessId === "dashport";

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Grid container direction="row" alignItems="flex-start">
      {atleteAccount && atleteAccount.perfil === 1 && (
        <Grid item xs={12} style={{ margin: "20px" }}>
          <SimpleDialogDemo buttonText={"Crear una Empresa"}>
            <BusinessCreate />
          </SimpleDialogDemo>
        </Grid>
      )}

      <Grid item xs={12}>
        <hr />
        <Typography gutterBottom variant={"h2"} component="h2">
          {business && business.name}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Tabs
          value={tabValue}
          onChange={handleChangeTab}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Datos generales del negocio" />
          <Tab label="Páginas Web" />
          <Tab label="Totales por evento" />
          {showVariosTab && <Tab label="Varios" />}
        </Tabs>
      </Grid>

      <Grid item xs={12}>
        <TabPanel value={tabValue} index={0}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <BusinessConfiguration business={business} />
            </Grid>

            {businessGeneralData &&
              business &&
              businessGeneralData[business.businessId] &&
              businessGeneralData[business.businessId].businessData &&
              businessGeneralData[business.businessId].businessData
                .businessType &&
              businessGeneralData[
                business.businessId
              ].businessData.businessType.includes("padel") && (
                <Grid item xs={12}>
                  <TournamentsContainer business={business} />
                </Grid>
              )}
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          <Grid container spacing={2}>
            {atleteAccount && atleteAccount.perfil === 1 && business && (
              <Grid item xs={12} style={{ margin: "20px" }}>
                <SimpleDialogDemo buttonText={"Crear una Web nueva"}>
                  <BusinessWebCreate businessId={business.businessId} />
                </SimpleDialogDemo>
              </Grid>
            )}

            <Grid item xs={12}>
              <OrganizerWebContainer business={business} />
            </Grid>
          </Grid>
        </TabPanel>

        <TabPanel value={tabValue} index={2}>
          <Grid container spacing={2}>
            {business && (
              <Grid item xs={12}>
                <TotalesEventos
                  listaEventosAll={events}
                  businessIdProp={business.businessId}
                />
              </Grid>
            )}
          </Grid>
        </TabPanel>

        {showVariosTab && (
          <TabPanel value={tabValue} index={3}>
            <Grid container spacing={2}>
              {atleteAccount &&
                atleteAccount.perfil === 1 &&
                business &&
                business.businessId === "dashport" && (
                  <>
                    <Grid item xs={12} style={{ margin: "20px" }}>
                      <SimpleDialogDemo
                        buttonText={"Ver cuentas"}
                        fullScreen={true}
                      >
                        <DownloadEventsDeposits />
                      </SimpleDialogDemo>
                    </Grid>

                    <Grid item xs={12} style={{ margin: "20px" }}>
                      <SimpleDialogDemo
                        buttonText={"PARTICIPANTES DE LOS EVENTOS DEL NEGOCIO"}
                        fullScreen={true}
                      >
                        <ParticipantsData businessId={business.businessId} />
                      </SimpleDialogDemo>

                      <SimpleDialogDemo
                        buttonText={"Demo registros de basket"}
                        fullScreen={true}
                      >
                        <GameContainer />
                      </SimpleDialogDemo>

                      <SimpleDialogDemo
                        buttonText={"Cotizador DEMO"}
                        fullScreen={true}
                      >
                        <ListaCotizaciones />
                      </SimpleDialogDemo>
                      <SimpleDialogDemo
                        buttonText={"Descargar Data participantes de un negocio"}
                        fullScreen={true}
                      >
                        <ExportInscritosByBusiness />
                      </SimpleDialogDemo>

                      <SimpleDialogDemo
                        buttonText={"Acceso a usuario multiples eventos"}
                        fullScreen={true}
                      >
                        <AddUserMultipleEvents />
                      </SimpleDialogDemo>

                      <SimpleDialogDemo
                        buttonText={"WhatsApp Chats"}
                        fullScreen={true}
                      >
                        <Chats />
                      </SimpleDialogDemo>

                    </Grid>
                  </>
                )}
            </Grid>
          </TabPanel>
        )}
      </Grid>
    </Grid>
  );
}